import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pagamento-cartao-cielo',
  templateUrl: './pagamento-cartao-cielo.component.html',
  styleUrls: ['./pagamento-cartao-cielo.component.scss']
})
export class PagamentoCartaoCieloComponent implements OnInit {

  @Input("params") params:any     = {};
  @Input("total")   total         = 0;
  @Input("dataItem") dataItem:any = null;

  constructor(){}  

  /***
   * 
   * Inicializa o dataItem
   * 
   */
  initDataItem(){

    if(this.dataItem == null){
      
      this.dataItem = {
        numero_cartao: "",
        data_validade: "",
        codigo_seguranca: "",
        nome_portador: "",
        parcelas: ""  
      }

    }  

  }
  /**
   * 
   * Change valor parcela
   * 
   */
  changeValueParcela(parcelas){

    this.dataItem.parcelas = parcelas; 

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{}

}
